window.PH = window.PH || {};

PH.catalog = {
  products: [],
  collectionHandle: 'perfumes',
  pageLimit: 250,

  async load() {
    PH.log('Cargando catálogo real desde Shopify...');

    let page = 1;
    let allProducts = [];
    let keepLoading = true;

    while (keepLoading) {
      const url = `/collections/${this.collectionHandle}/products.json?limit=${this.pageLimit}&page=${page}`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`No se pudo cargar catálogo: ${url}`);
      }

      const data = await response.json();
      const products = data.products || [];

      allProducts = allProducts.concat(products);

      if (products.length < this.pageLimit) {
        keepLoading = false;
      } else {
        page++;
      }
    }

    this.products = allProducts.map(product => {
      if (PH.product && typeof PH.product.normalize === 'function') {
        return PH.product.normalize(product);
      }

      return product;
    });

    PH.state.catalog = this.products;

    PH.log(`Catálogo cargado usando PH.product: ${this.products.length} perfumes`);
    PH.log(this.products);

    return this.products;
  }
};